"use strict";

exports.__esModule = true;
exports.createSlotVeloAPIFactory = void 0;
var _slotsPlaceholderVeloAPIFactory = require("./slotsPlaceholderVeloAPIFactory");
exports.createSlotVeloAPIFactory = _slotsPlaceholderVeloAPIFactory.createSlotVeloAPIFactory;
//# sourceMappingURL=index.js.map